import { mainSiteUrl, trustBadges } from '@/mocks/categories';
import CategoryDropdown from '@/components/feature/CategoryDropdown';

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20fashion%20composition%20on%20warm%20sandy%20beige%20textured%20surface%20featuring%20sneakers%20leather%20goods%20folded%20knitwear%20and%20delicate%20accessories%20arranged%20in%20an%20organic%20scattered%20pattern%20soft%20diffused%20morning%20light%20gentle%20shadows%20editorial%20product%20photography%20with%20harmonious%20earthy%20tones%20and%20ample%20negative%20space&width=1800&height=1200&seq=kakobuy-hero-v2-06&orientation=landscape"
        alt="Kakobuy Spreadsheet fashion products flat lay"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 flex flex-col items-center text-center pt-20 pb-12">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
          Kakobuy Spreadsheet
        </h1>
        <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-white/90 mt-3 font-light italic">
          The Ultimate 2026 Buying Guide
        </p>
        <p className="text-white/70 text-sm md:text-base max-w-xl mt-6 leading-relaxed">
          Discover the latest <strong className="text-white">Kakobuy Spreadsheet</strong> links, trusted sellers, buying guides, and safe shopping resources — all verified and updated daily for smarter purchasing decisions.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 text-white text-sm font-semibold hover:bg-white/30 transition-all duration-200 cursor-pointer"
          >
            Browse Trusted Sellers
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="mt-10 w-full max-w-md">
          <CategoryDropdown />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10">
          {trustBadges.map((badge) => (
            <div key={badge.label} className="flex items-center gap-2 text-white/80 text-xs md:text-sm whitespace-nowrap">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-sm`}></i>
              </span>
              <span>{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}